import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import RaekUd from "./sections/RaekUd";
import SendDinBesked from "./sections/SendDinBesked";
import SocialeUdposter from "./sections/SocialeUdposter";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <RaekUd />
      <SendDinBesked />
      <SocialeUdposter />
      <Footer />
    </div>;
}